import sportsApi from './../../utils/sportsApi';

export const fetchRightsholdersWithOnoAccounts = async (clientId: number) => {
    const response = await sportsApi
        .url(`/clients/${clientId}/rightsholders-with-oo-accounts`)
        .get()
        .json()
        .catch(() => []);

    if (Array.isArray(response)) {
        return response;
    }

    return [];
};
